import {
  styled,
  TableRow as MuiTableRow,
  tableRowClasses,
} from '@mui/material';

export const TableRow = styled(MuiTableRow)(({ theme }) => ({
  [`&.${tableRowClasses.head}`]: {
    boxShadow: 'none',

    '&:nth-of-type(odd)': {
      backgroundColor: 'transparent',
    },
  },
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}));
